import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Orientation } from "expo-screen-orientation";

export interface DeviceState {
  orientation: Orientation;
}

const initialState: DeviceState = {
  orientation: 0,
};

export const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setOrientation: (state, action: PayloadAction<Orientation>) => {
      state.orientation = action.payload;
    },
  },
});

export const { setOrientation } = deviceSlice.actions;

export default deviceSlice.reducer;
